import * as Yup from 'yup';

export const schema = Yup.object().shape({
  SocialManagerContentContent: Yup.string().required('وارد کردن محتوا الزامی است'),
  SocialManagerContentFile: Yup.string().required('وارد کردن فایل محتوا الزامی است'),
  SocialManagerContentFileName: Yup.string().required('وارد کردن نام فایل الزامی است'),
});
